import { BillingFinanceTranslation } from 'locales/de/pages/Billing/finance';

const en: BillingFinanceTranslation = {
  exportTitle: 'Export FSV / DMS',
  approveTitle: 'Invoices for Approval',
  exportDate: 'Export Date',
  openInDMS: 'Open in DMS',
  fileName: 'File Name',
  exportUser: 'Creator',
  unknownExportUser: 'unknown',

  tabs: {
    approved: 'Approved Invoices',
    final: 'Exported Invoices',
    csv: 'CSV Invoices'
  },
  mutation: {
    exportSuccessful: 'The invoices were successfully prepared for export.',
    exportFailed: 'The invoices could not be prepared for export.',
    approveSuccessful: 'The invoices were successfully approved.',
    approveFailed: 'The invoices could not be approved.',
    denySuccessful: 'The invoices were successfully denied.',
    denyFailed: 'The invoices could not be denied.',
    splitInvoiceSuccessful: 'The invoice was successfully split.',
    splitInvoiceFailed: 'The invoice could not be split.',
    cancelSuccessful: 'The invoice was successfully cancelled.',
    cancelFailed: 'The invoices could not be cancelled.',
    deleteSuccessful: 'The invoices was deleted.',
    deleteFailed: 'The invoices could not be deleted.',
    equaliseTaxRateSuccesful: 'The tax rates were successfully adjusted.',
    equaliseTaxRateFailed: 'The tax rates could not be adjusted.'
  },
  splitOrChangeTaxDialog: {
    title: 'Note on the adjustment of tax rates',
    descripiton:
      'This invoice contains items with different tax rates and it is necessary for all invoice items to have the same tax rate for approval. You have two options:',
    splitInvoice:
      'You can use the "Split invoice" button to split the existing invoice into partial invoices. Each partial invoice only contains items with the same tax rate.',
    equaliseTaxRate:
      'With the "Equalise tax rates" button, all items in this invoice are set to the following tax rate: {{taxToChange}}',
    splitInvoiceButton: 'Split invoice',
    equaliseTaxRateButton: 'Equalise tax rates'
  },
  exportButton: 'Export Invoices',
  departmentFilter: 'Department',
  approveInvoicesDisabledTooltip: 'At least one incomplete invoice is selected',
  confirmationDialog: {
    exportTitle: 'Export Invoices to FSV / DMS',
    exportDialog:
      'Are you sure you want to export the selected invoices to FSV / DMS?\nThe invoices will be sent to the respective customers in two days.',
    approveTitle: 'Approve Invoices',
    approveDialog:
      'Are you sure you want to approve the selected invoices?\nThe invoice number and booking code will be automatically added to the invoice.',
    approveSplitInvoiceTitle: 'Split invoices due to different tax rates',
    approveSplitInvoiceDialog:
      'The invoice contains invoice items with different tax rates.\nThe invoice is therefore split into {{count}} invoices so that each invoice only contains items with the same tax rate',
    denyTitle: 'Deny Invoices',
    denyDialog: 'Are you sure you want to deny the selected invoices?',
    cancelTitle: 'Cancel Invoices',
    cancelDialog: 'Are you sure you want to cancel the selected invoices?',
    deleteTitle: 'Delete invoice',
    deleteDialog: 'Are you sure you want to delete this invoice?'
  }
};

export default en;
